export const typography = {
  fontFamily: '"Public Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  
  fontSize: {
    xs:    '0.75rem',    // 12px
    sm:    '0.85rem',    // 13.6px
    base:  '0.95rem',    // 15.2px
    md:    '1.05rem',    // 16.8px
    lg:    '1.15rem',    // 18.4px
    xl:    '1.25rem',    // 20px
    xxl:   '1.5rem',     // 24px
    h3:    '1.65rem',    // 26.4px
    h2:    '1.9rem',     // 30.4px
    h1:    '2.1rem',     // 33.6px
  },

  fontWeight: {
    regular:  400,
    medium:   500,
    semibold: 600,
    bold:     700,
    extrabold: 800,
  },

  lineHeight: {
    tight:  1.2,
    normal: 1.5,
    relaxed: 1.6,
  }
} as const;
